export default __webpack_public_path__ + "static/media/FuneralActivities.a6c261fb.mp3";